export default __webpack_public_path__ + "static/media/company.3df96aa4.svg";